const prepareBody = (metaInfo) => {
  return JSON.parse(metaInfo)
}

export { prepareBody }
